import { render } from "./ElectronicArchive.vue?vue&type=template&id=601fc38a&scoped=true"
import script from "./ElectronicArchive.vue?vue&type=script&lang=js"
export * from "./ElectronicArchive.vue?vue&type=script&lang=js"

import "./ElectronicArchive.vue?vue&type=style&index=0&id=601fc38a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601fc38a"]])

export default __exports__